'use strict';

import $ from 'jquery';

const splideOptions = () => {
	const products_per_row = mpro.config.catalog.products_per_row;

	return {
		'gap': '1rem',
		'pagination': false,
		'perPage': products_per_row.desktop,
		'perMove': products_per_row.desktop,
		'arrowPath': 'M31.959 19.325 12.634 0H7.773L27.77 19.995 7.764 40h4.859L31.96 20.664a.947.947 0 0 0-.001-1.339z',
		'padding': {
			'left': 0,
			'right': Math.round(100 / (products_per_row.desktop * 2 + 1)) + '%',
		},
		'breakpoints': {
			'992': {
				'perPage': Math.min(3, products_per_row.desktop),
				'perMove': Math.min(3, products_per_row.desktop),
				'padding': {
					'left': 0,
					'right': Math.round(100 / (Math.min(3, products_per_row.desktop) * 2 + 1)) + '%',
				},
			},
			'768': {
				'arrows': false,
				'perPage': products_per_row.mobile,
				'perMove': products_per_row.mobile,
				'padding': {
					'left': 0,
					'right': Math.round(100 / (products_per_row.mobile * 2 + 1)) + '%',
				},
			},
		},
		'clones': 1,
		'cloneStatus': false,
	};
};

// Replace recursively all keys from an object
const replaceKeysInObject = (obj) => Object.entries(obj).reduce((acc, [key, value]) => {
	if (key in OPTIONS_MAP) { acc[OPTIONS_MAP[key]] = value; return acc; }
	if (typeof value === 'object' && value !== null) {
		if (value.length) { acc[key] = value.map(cur_val => { return replaceKeysInObject(cur_val); }); return acc; }
		else { acc[key] = replaceKeysInObject(value); return acc; }
	}
	if (key in OPTIONS_MAP) {
		acc[OPTIONS_MAP[key]] = value; return acc;
	}

	acc[key] = value; return acc;
}, {});

const OPTIONS_MAP = {
	'per_page': 'perPage',
	'per_move': 'perMove',
	'fixed_width': 'fixedWidth',
	'fixed_height': 'fixedHeight',
	'auto_width': 'autoWidth',
	'auto_height': 'autoHeight',
	'height_ratio': 'heightRatio',
	'is_navigation': 'isNavigation',
	'arrow_path': 'arrowPath',
	'slide_focus': 'slideFocus',
	'no_drag': 'noDrag',
	'clone_status': 'cloneStatus',
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	// Find items for the plugin selector
	const $collection = $container.find('div[data-slider]');

	// No need to go further
	if (!$collection.length) {
		return;
	}

	const loadSplide = async () => {

		// Load the splidejs lib (lazy)
		const { default: Splide } = await import('@splidejs/splide');

		const getOptions = (obj) => {
			const options = $.extend({}, splideOptions(), replaceKeysInObject(obj) || {});

			return options;
		};

		// Filter simple sliders (no thumbnails)
		const $simpleSliders = $collection.filter(function () {
			let options = getOptions($(this).data('slider'));
			return !options.thumbnails;
		});

		$simpleSliders.each(function () {
			const options = getOptions($(this).data('slider'));
			const splide = new Splide(this, options).mount();
			$(this).data('splide', splide);
		});

		// Sliders with thumbnails
		const $thumbSliders = $collection.filter(function () {
			let options = getOptions($(this).data('slider'));
			return options.thumbnails;
		});

		// Init spiders with thumbnails last
		$thumbSliders.each(function () {
			const $splideSource = $(this);
			const options = getOptions($splideSource.data('slider'));
			let splide;

			if ($(options.thumbnails).length > 0) {
				splide = new Splide(this, options).sync($(options.thumbnails).data('splide')).mount();
				$splideSource.data('splide', splide);
			}
			else {
				splide = new Splide(this, options).mount();
				$splideSource.data('splide', splide);
			}

			// Remove fancybox from clone slides
			$splideSource.find('.splide__slide--clone [data-fancybox]').removeAttr('data-fancybox');

			splide.on('moved', (idx) => {
				const $currentSlide = $splideSource.find('.splide__slide').eq(idx);

				// Sync attribute with splide image
				const $currentProductImage = $currentSlide.find('[data-image]');
				if ($currentProductImage.length && $currentProductImage.data('image') > 0 && mpro.config?.product?.image_reload_trigger) {
					const $relateOption = $("select[name^='items[product][attributes]'] option[data-image=" + $currentProductImage.data('image') + "]");
					const $relateInput = $("input[name^='items[product][attributes]'][data-image=" + $currentProductImage.data('image') + "]");

					// Attributes as selects
					if ( $relateOption.length && $relateOption.closest('select').val() !== $relateOption.attr('value') ) {
						$relateOption.closest('select').val($relateOption.attr('value')).trigger('change');
					}

					// Attributes as tags
					if ( $relateInput.length && $("input[name^='items[product][attributes]']:checked").val() !== $relateInput.attr('value') ) {
						$relateInput.prop("checked", true).trigger('change');
					}
				}

				// Play the 360 gallery for the first time
				const $gallery360 = $currentSlide.find('.cloudimage-360');
				if ($gallery360.length && !$gallery360.data('first-autoplay')) {
					$gallery360.data('first-autoplay', true);
					$gallery360.find('canvas').trigger('click');
				}
			});
		});
	};

	// Defer loading for mobile devices
	if (mpro.isMobileScreen() && document.URL.includes('splide-delay')) {
		const delay = Number((new URLSearchParams(document.URL)).get('splide-delay') || 5);
		window.setTimeout(loadSplide, delay * 1000);
	}
	else {
		loadSplide();
	}
});

export default mpro;
